const NGROK_SUFFIXES = [".ngrok-free.app", ".ngrok-free.dev"];

export function isNgrokUrl(source?: string | null) {
  if (!source) return false;
  try {
    const hostname = new URL(source).hostname;
    return NGROK_SUFFIXES.some((suffix) => hostname.endsWith(suffix));
  } catch {
    return false;
  }
}

export const ngrokHeaders = {
  "ngrok-skip-browser-warning": "true",
};
